import React, { useState, useEffect, createContext } from 'react';
import { useParams } from 'react-router';
import { Form, message, Spin, Typography } from 'antd';
import { fetchMCPServerAppDetails, saveMCPServerAppDetails } from './MCPServerApis';
import { generateInitialValue, generateBasicDetails, generateResearchData } from './MCPServerHelper';
import { formKeys } from './MCPServerConstants';
import BasicDetails from './components/BasicDetails';
import Logo from './components/Logo';
import Attributes from './components/Attributes';
import { SIZE } from '../Helper/Constant';

const { Text, Title } = Typography;

export const MCPResearchContext = createContext();

const MCPResearchUI = ({ user }) => {
    const { id } = useParams();
    const USERNAME = user.email.split('@')[0];
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [mcpAppDetails, setMcpAppDetails] = useState(null);
    const [initialValue, setInitialValue] = useState({});

    useEffect(() => {
        if (!id) {
            return;
        }
        setLoading(true);
        fetchMCPServerAppDetails(id)
            .then((data) => {
                setMcpAppDetails(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    useEffect(() => {
        if (mcpAppDetails) {
            setInitialValue(generateInitialValue(mcpAppDetails));
        }
    }, [mcpAppDetails]);

    if (!id) {
        return (
            <div className='container'>
                <div className='ns-flex ns-flex_vertical ns-flex_centered'>
                    <Text>Invalid MCP app ID provided</Text>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className='container'>
                <div className='ns-flex ns-flex_vertical ns-flex_centered'>
                    <Spin tip='Loading...' />
                </div>
            </div>
        );
    }

    if (!mcpAppDetails) {
        return (
            <div className='container'>
                <div className='ns-flex ns-flex_vertical ns-flex_centered'>
                    <Text>No MCP app details found</Text>
                </div>
            </div>
        );
    }

    const onSave = async (values) => {
        console.log('onFinish : ', values);
        setSaving(true);

        const appLogo = values['appLogo'];
        const basicDetails = generateBasicDetails(values[formKeys.basicDetails]);
        const researchData = generateResearchData(values[formKeys.attrCategory], mcpAppDetails.questionCategories);
        researchData['assigned_to'] = USERNAME;

        const postData = {
            appLogo,
            researchData,
            basicDetails,
        };

        console.log('postData', postData);

        await saveMCPServerAppDetails(id, postData)
            .then((response) => {
                console.log('saveResponse', response);
                if (response.errors && response.errors.length > 0) {
                    message.error('Errors in saving: ' + response.errors.join(', '));
                } else {
                    message.success('MCP Server App Details saved successfully');
                }
                setSaving(false);
            })
            .catch((error) => {
                console.log('error', error);
                message.error('Failed to save MCP Server App Details: ' + error.message);
                setSaving(false);
            });

        // setSaving(false);
    };

    const onFormValuesChange = (changedValues, allValues) => {
        console.log('changedValues', changedValues);
    };

    const onFinishFailed = () => {
        message.info('Please save changes first.');
    };

    return (
        <MCPResearchContext.Provider value={{ id, form, mcpAppDetails, saving, USERNAME }}>
            <Form
                form={form}
                initialValues={initialValue}
                onValuesChange={onFormValuesChange}
                onFinish={onSave}
                onFinishFailed={onFinishFailed}
                size={SIZE.SMALL}
                scrollToFirstError
            >
                <BasicDetails />
                <Logo />
                <Attributes />
            </Form>
        </MCPResearchContext.Provider>
    );
};

export default MCPResearchUI;
